(function () {
	'use strict';
	$(document).ready(function () {
		const quotes_swiper = new Swiper('.quotes-swiper', {
			loop: true,
			spaceBetween: 30,
			slidesPerView: 1,
			autoHeight: true,
			pagination: {
				el: '.quotes-swiper .swiper-pagination',
				type: 'bullets',
			},
		});

		$('.homepage .quotes-container').on('click', function() {
			quotes_swiper.slideNext();
		});

		const partners_swiper = new Swiper('.partners-swiper', {
			speed: 400,
			slidesPerView: 1,
			spaceBetween: 20,
			loop: true,
			autoplay: {
				delay: 3000,
			},
			pagination: {
				el: '.partners-swiper .swiper-pagination',
				type: 'bullets',
				clickable: true,
				dynamicBullets: true,
			},
			breakpoints: {
				480: {
					slidesPerView: 2,
				},
				640: {
					slidesPerView: 4,
					pagination: {
						dynamicBullets: false,
					},
				},
				991: {
					slidesPerView: 6,
				},
			},
		});

		if (window.matchMedia("(max-width: 575px)").matches) {
			$('.homepage .innovations .tiles a.innovation').on('click', function(e) {
				if (!$(this).hasClass('hover')) {
					e.preventDefault();
					$(this).addClass('hover');
				}
			});
		}
	});
}(jQuery));
